import { CORE_SECTTION_SCORES } from "../config";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";





export const getSkillScore = (skills: ResumeAnalysis["skills"], maxScoreOfSection: number) => {
  const skillScore = skills.descriptionAnalysis.length > 0 ? maxScoreOfSection * CORE_SECTTION_SCORES.skills.present : 0;

  return {
    totalScore: skillScore,
    skillScore
  };
}
